<template>
  <div v-if="toggled && user" class="action--modal" @click.self="emitToggle">
    <form class="tile action-form" @submit.prevent="submit">
      <p class="content__heading">Delete User</p>
      <p class="text__center">This user will no longer be capable of logging into the app</p>
      <p class="flex__between mt-15">
        <span class="text__bold">Name:</span>
        <span>{{user.name}}</span>
      </p>
      <p class="flex__between mt-15">
        <span class="text__bold">Email:</span>
        <span>{{ user.email }}</span>
      </p>
      <div class="flex__between mt-15">
        <span class="text__bold text__red" @click.prevent="emitToggle">Cancel</span>
        <button class="btn btn__small btn__green" @click.prevent="submit">Delete</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["toggled", "user"],
  methods: {
    ...mapActions(["startDeleteUser"]),
    emitToggle() {
      this.$emit("toggleDelete");
    },
    async submit() {
      try {
        await this.startDeleteUser(this.user._id);
        this.$emit("clearDeleteUser");
      } catch (err) {
        // do nothing
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>